<p class="text-sm text-grey-800 flex items-start gap-2 pb-3">
  <vw-icon-svg [iconUrl]="iconUrl" additionalClasses="cursor-pointer w-5 pt-0.5" width="24px"
    height="24px"></vw-icon-svg>
  {{ label }}
</p>